import { render } from "./OnboardingChecklist.vue?vue&type=template&id=41e2b9d8&scoped=true"
import script from "./OnboardingChecklist.vue?vue&type=script&lang=js"
export * from "./OnboardingChecklist.vue?vue&type=script&lang=js"

import "./OnboardingChecklist.vue?vue&type=style&index=0&id=41e2b9d8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41e2b9d8"]])

export default __exports__